import { useState } from 'react';
import PaymentByPeriodsHeader from './PaymentByPeriodsHeader';
import PaymentByPeriodsTable from './PaymentByPeriodsTable';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Button, FormControl, IconButton, MenuItem, Select } from '@mui/material';
import SendPaymentsModal from '../components/SendPaymentsModal';


const PaymentsByPeriodsScreen = ({selectedYear, selectedPeriod, setSelectedUser}) => {
  const [sendPaymentsModalIsOpen, setSendPaymentsModalIsOpen] = useState(false);

  return (
    <div>
      <PaymentByPeriodsHeader selectedYear={selectedYear} selectedPeriod={selectedPeriod} setSendPaymentsModalIsOpen={setSendPaymentsModalIsOpen} />
      <PaymentByPeriodsTable selectedYear={selectedYear} selectedPeriod={selectedPeriod} setSelectedUser={setSelectedUser}/>

      <SendPaymentsModal open={sendPaymentsModalIsOpen} setOpen={setSendPaymentsModalIsOpen} periodID={ sendPaymentsModalIsOpen }  />
    </div>
  );
}

export default PaymentsByPeriodsScreen;